import { render, staticRenderFns } from "./ForumChatThreadCardHeaderTimestamp.vue?vue&type=template&id=9430968e&scoped=true"
import script from "./ForumChatThreadCardHeaderTimestamp.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadCardHeaderTimestamp.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadCardHeaderTimestamp.vue?vue&type=style&index=0&id=9430968e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9430968e",
  null
  
)

export default component.exports